<!-- This component has been deprecated since it lacks necessary accessibility features. -->
<!-- Prefer using base-radio-checkbox.vue instead. -->

<template>
  <div class="radio" :class="cssClasses">
    <input
      :id="id"
      type="radio"
      :value="value"
      :name="name"
      :checked="isChecked"
      :disabled="disabled"
      class="radio__element"
      @change="update"
      @click="onClick">

    <label :for="id" :class="['radio__label', classesLabel, labelSize]">
      <template v-if="!useSubText">
        <slot></slot>
        {{ labelText }}
      </template>

      <span v-else class="radio__label-text">
        <span class="radio__label-main-text">
          {{ labelText }}
        </span>

        <span class="radio__label-sub-text">
          <slot></slot>
        </span>
      </span>
      <span v-if="useChipText" class="radio__chip-text">{{ chipText }}</span>
    </label>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Boolean],
      required: true
    },
    name: {
      type: String,
      required: true
    },
    isChecked: {
      type: [String, Boolean],
      default: false
    },
    id: {
      type: String,
      required: true
    },
    labelText: {
      type: String,
      required: true
    },
    classesLabel: {
      type: [String, Array, Object],
      default: null
    },
    size: {
      type: String,
      default: 'large'
    },
    useSubText: {
      type: Boolean,
      default: false
    },
    useChipText: {
      type: Boolean,
      default: false
    },
    chipText: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    labelSize() {
      return `radio__label--${this.size}`
    }
  },
  methods: {
    update(e) {
      this.$emit('change', this.value)
    },
    onClick() {
      this.$emit('click', this.value)
    }
  }
}
</script>

<style lang="scss">
.radio {
  position: relative;
}

.radio__element {
  opacity: 0;
  position: absolute;
  &:focus + label:before {
    outline: 1px solid color(black);
    outline-offset: 2px;
  }
  &:focus:not(:focus-visible) + label:before { outline: none; }
}

.radio__label {
  position: relative;
  display: flex;
  align-items: center;

  &:before {
    content: '';
    flex-shrink: 0;
    border: 2px solid gray;
    border-radius: 50%;
    transition: all 100ms linear;
  }

  &:after {
    content: '' ;
    position: absolute;
    top: 50%;
    transform: translateY(-50%) translateX(-2rem);
    background-image: url("data:image/svg+xml,%3Csvg width='30' height='28' viewBox='0 0 30 28' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.034 27.39L0 16.842l3.3-3.424 7.27 6.95L26.279.8 30 3.764z' fill='%23FFF' fill-rule='evenodd'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    opacity: 0;
    transition: transform 120ms linear, opacity 120ms linear;
  }

  &:hover {
    cursor: pointer;
  }
}

.radio__label.radio__label--medium {
  &:before {
    width: 1.25rem;
    height: 1.25rem;
    margin-right: measure(quarter);
  }

  &:after {
    left: .25rem;
    width: .8rem;
    height: .7rem;
  }
}

.radio__label.radio__label--large {
  &:before {
    width: 1.875rem;
    height: 1.875rem;
    margin-right: measure(half);
  }

  &:after {
    left: .4rem;
    width: 1.1rem;
    height: 1.1rem;
  }
}

.radio__element:disabled + .radio__label {
  color: color(gray-2);

  &:before {
    background-color: color(gray-4);
    border-color: color(gray-3);
  }
}

.radio__element:checked + .radio__label {
  &:before {
    background-color: color(green-2);
    border-color: color(green-2);
  }

  &:after {
    transform: translateY(-50%) translateX(0);
    opacity: 1;
  }
}

.radio__label-text {
  display: flex;
  flex-direction: column;
}

.radio__label-sub-text-container > *:not(:last-child) {
  margin-bottom: measure(eighth);
}

.radio__label-sub-text {
  @include body-smaller;
  display: inline-block;
}

.radio__label-sub-text-price {
  display: block;
  @include body-semi-bold;
}

.register-container__radio .radio__label:before {
  margin-right: measure(quarter);
}

.radio__chip-text {
  @include caption-semi-bold;
  margin: 0 0 0 measure(half);
  align-self: start;
  padding: measure(eighth);
  border: 1px solid color(yellow-1);
  background-color: color(yellow-2);
  line-height: 1;
  font-size: 12px;
}

.radio--blue .radio__element:checked + .radio__label::before {
  background-color: color(blue-1);
  border-color: color(blue-1);
}

</style>
